import React from 'react'
import { Breadcrumb, Container } from 'reactstrap'
import List from './component/List'

const DisputeListPage = () => {
  return (
     <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumb title="Project List" pageTitle="Projects" />
                    <List />
                </Container>
            </div>
        </React.Fragment>
  )
}

export default DisputeListPage
